import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { Card } from "@/components/portal/ui";

const LABEL = { sent: "Accepted by provider", retrying: "Retrying automatically", failed: "Failed — needs attention", rejected: "Rejected by provider", sending: "Sending" };
const why = (e) => { try { return JSON.parse(e).message || e; } catch { return e; } };

export function EmailDelivery() {
  const [d, setD] = useState(null);
  const [filter, setFilter] = useState("");
  const load = () => http.get(`/admin/academics/email-log${filter ? `?status=${filter}` : ""}`).then((r) => setD(r.data)).catch(() => setD({ counts: {}, rows: [] }));
  useEffect(() => { load(); }, [filter]); // eslint-disable-line react-hooks/exhaustive-deps
  const resend = async (id) => {
    try { const r = await http.post(`/admin/academics/email-log/${id}/resend`); toast[r.data.ok ? "success" : "error"](r.data.ok ? "Resent — accepted by provider" : "Resend failed; see the error"); load(); }
    catch (er) { toast.error(er?.response?.data?.detail || "Resend failed"); }
  };
  if (!d) return null;
  return (
    <Card className="p-5 mb-6" data-testid="email-delivery">
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <div className="font-medium text-[#1A1918]">Email Delivery</div>
        <div className="flex flex-wrap gap-2 text-xs">
          {["", "failed", "rejected", "retrying", "sent"].map((s) => (
            <button key={s || "all"} onClick={() => setFilter(s)} data-testid={`email-filter-${s || "all"}`}
              className={`px-2.5 py-1 rounded-full border whitespace-nowrap ${filter === s ? "bg-[#1A1918] text-white border-[#1A1918]" : "border-[#E5E1D8] text-[#6B665E]"}`}>
              {s ? `${s} (${d.counts[s] ?? 0})` : "all"}
            </button>
          ))}
        </div>
      </div>
      <p className="text-xs text-[#8A998C] mt-1">Owner notices go to the ADMIN_EMAIL inbox. Temporary provider errors are retried automatically for several hours; permanent failures alert the owner and can be resent here.</p>
      <div className="mt-3 divide-y divide-[#E5E1D8] text-sm max-h-[420px] overflow-y-auto">
        {d.rows.length === 0 && <div className="py-3 text-[#8A998C]">No emails in this view.</div>}
        {d.rows.map((r) => (
          <div key={r.id} className="py-2 flex flex-wrap justify-between gap-2" data-testid={`email-row-${r.id}`}>
            <div className="min-w-0">
              <div className="truncate">{r.subject}</div>
              <div className="text-xs text-[#8A998C]">{r.kind} · {r.to} · {new Date(r.created_at).toLocaleString()} · {r.attempts} attempt{r.attempts === 1 ? "" : "s"}{r.last_error ? ` · HTTP ${r.http_status}: ${why(r.last_error).slice(0, 120)}` : ""}</div>
            </div>
            <div className="flex items-center gap-3 text-xs shrink-0">
              <span className={r.status === "sent" ? "text-[#667A66]" : "text-[#9E4F4F]"} data-testid={`email-status-${r.id}`}>{LABEL[r.status] || r.status}</span>
              {["failed", "rejected", "retrying"].includes(r.status) && r.kind !== "password_reset" &&
                <button onClick={() => resend(r.id)} className="text-[#9F634E] hover:underline" data-testid={`email-resend-${r.id}`}>Resend</button>}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
